(() => {
  'use strict';
  const STOCK='kp_catalog_hide_out_of_stock_v1';
  const MACHINE='kp_machine_hide_incompatible_v1';
  const cache=new Map();
  let busy=false,timer;

  const label={100:'Pleje & rengøring',110:'Serviceværktøj',200:'O-ringe & pakninger',300:'Fittings & slanger',310:'Vandtank & vandtilslutning',320:'Pumper, flowmetre & afløb',330:'Magnetventiler',340:'Ventiler & damp/vand',350:'Dampdyser & steamarme',400:'Kaffe- & bryggekredsløb',410:'Filter, portafilter & bryggruppe',500:'Kedler',510:'Varmelegemer',600:'Printkort & elektronik',610:'Sensorer, prober & termostater',620:'Kabler, stik & sikringer',700:'Kværn & tamper',710:'Kværnsten & kværnknive',800:'Kabinet & paneler',810:'Drypbakker',900:'Øvrige reservedele'};
  const txt=p=>`${p.type||''}|${p.title||''}|${Array.isArray(p.tags)?p.tags.join('|'):p.tags||''}`.toLowerCase();
  function code(p){
    const s=txt(p),type=String(p.type||'').toLowerCase(),title=String(p.title||'').toLowerCase();
    if(type.includes('o-ringe')||/\bo-?ring\b|pakning|tætning/.test(title))return'200';
    if(type.includes('fittings')||type.includes('slanger'))return'300';
    if(type.includes('vandtank'))return'310';
    if(type.includes('filterkurv')||type.includes('filter, portafilter')||/portafilter|filterkurv|shower|brusesi|gruppehovedskrave/.test(title))return'410';
    if(type.includes('kværnknive')||/kværnsten|burr|kværnkniv/.test(title))return'710';
    if(type==='kedel'||type.includes('kedler'))return'500';
    if(type.includes('varmelegeme')||/thermoblock|thermojet|thermocoil|varmelegeme/.test(title))return'510';
    if(type.includes('drypbakke')||title.includes('drypbakke'))return'810';
    if(type.includes('kabinet')||/panel|cover|dæksel|maskinfod|gummifod/.test(title))return'800';
    if(type.includes('pleje'))return/unbrako|værktøj/.test(title)?'110':'100';
    if(type.includes('elektronik')){if(/sensor|ntc|reed|mikroswitch|kontakt|thermostat|termostat|probe/.test(title))return'610';if(/kabel|cable|stik|sikring|fuse|crimp/.test(title))return'620';return'600';}
    if(type.includes('dampdyse')||/steam arm|steamarm|damparm|dampstav|dampdyse|mælkeskummerdyse/.test(title))return'350';
    if(/magnetventil|solenoid/.test(s))return'330';
    if(/venturi|overtryksventil|\bopv\b|afkalkningsventil|drænventil|anti-?vakuum|vakuumventil|ventilblok|ventilvælger|dampventil|americano-ventil/.test(title))return'340';
    if(type.includes('pumpe')||/flowmeter|flow meter|vibrationspumpe|luftpumpe|steam pump|kaffepumpe/.test(title))return/slange|hose|tube/.test(title)?'300':'320';
    if(type.includes('kaffe-vand'))return/sensor|ntc|thermostat|termostat|probe/.test(title)?'610':/sikring|fuse/.test(title)?'620':'400';
    if(type.includes('damp- & vand')||type.includes('vandkredsløb')){if(/sensor|ntc|thermostat|termostat|probe/.test(title))return'610';if(/sikring|fuse/.test(title))return'620';if(/slange|hose|tube|clip|fitting|kobling|connector/.test(title))return'300';return'340';}
    if(type.includes('tamper')||/kværn|tamper|bønnebeholder/.test(title))return/kværnsten|burr|kværnkniv/.test(title)?'710':'700';
    if(/thermostat|termostat/.test(s))return'610';
    return'900';
  }
  function suffix(p){const sku=String(p.variants?.[0]?.sku||'').trim().toUpperCase();if(sku){const x=sku.replace(/^SP/,'').replace(/[^A-Z0-9]/g,'');if(x)return x;}return'P'+String(p.id||'').replace(/\D/g,'');}
  const number=p=>`KP-${code(p)}-${suffix(p)}`;
  const grid=()=>document.querySelector('#product-grid');
  const items=()=>grid()?[...grid().children].filter(x=>x.matches('.grid__item')):[];
  function handle(item){const a=item.querySelector('a[href*="/products/"]');if(!a)return'';return(a.getAttribute('href')||'').match(/\/products\/([^/?#]+)/)?.[1]||'';}
  async function product(h){if(cache.has(h))return cache.get(h);const q=fetch(`${window.Shopify?.routes?.root||'/'}products/${encodeURIComponent(h)}.js`,{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).catch(()=>null);cache.set(h,q);return q;}
  const out=item=>!!item.querySelector('.kp-stock-dot--red');
  function rank(item){if(item.matches('.kp-machine-fit--pass,.kp-machine-fit--universal'))return 0;if(item.matches('.kp-machine-fit--pdc,.kp-machine-fit--unknown'))return 1;if(item.classList.contains('kp-machine-fit--fail'))return 3;return 2;}
  function addNo(item,no,c){item.dataset.kpItemNumber=no;let el=item.querySelector('.kp-item-number');if(!el){el=document.createElement('span');el.className='kp-item-number';const h=item.querySelector('.card__heading');h?.parentNode?.insertBefore(el,h);}if(el){el.textContent=`Varenr. ${no}`;el.title=label[c]||label[900];}}
  function visibility(list){const hs=localStorage.getItem(STOCK)==='1',hm=localStorage.getItem(MACHINE)==='1';list.forEach(i=>i.hidden=(hs&&i.dataset.kpStock==='out')||(hm&&i.classList.contains('kp-machine-fit--fail')));}
  function controls(list){const hs=localStorage.getItem(STOCK)==='1';document.querySelectorAll('[data-kp-hide-out-of-stock]').forEach(x=>x.checked=hs);const n=list.filter(i=>i.dataset.kpStock!=='out').length,o=list.length-n;document.querySelectorAll('[data-kp-stock-summary]').forEach(x=>x.textContent=`${n} på lager · ${o} ikke på lager`);}
  const markup=()=>{const d=document.createElement('div');d.className='kp-stock-control';d.innerHTML='<label class="kp-stock-toggle"><input type="checkbox" data-kp-hide-out-of-stock><span>Skjul varer der ikke er på lager</span></label><small data-kp-stock-summary></small>';return d;};
  function ensure(){
    if(!grid())return;
    const m=document.querySelector('.kp-machine-filterbar');
    const standalone=[...document.querySelectorAll('.kp-stock-filterbar')];
    if(m){
      standalone.forEach(x=>x.remove());
      const inside=[...m.querySelectorAll('[data-kp-hide-out-of-stock]')];
      if(!inside.length){
        const d=markup();
        d.classList.add('kp-machine-filterbar__stock');
        m.appendChild(d);
      }else if(inside.length>1){
        inside.slice(1).forEach(x=>x.closest('.kp-stock-control')?.remove());
      }
      return;
    }
    if(standalone.length){
      standalone.slice(1).forEach(x=>x.remove());
      return;
    }
    const g=grid(),box=g.closest('.product-grid-container')||g.parentElement;
    if(!box)return;
    const b=document.createElement('div');
    b.className='kp-stock-filterbar';
    b.innerHTML='<div class="kp-stock-filterbar__copy"><span>Lagerstatus</span><strong>Vis de varer du kan bestille nu</strong></div>';
    b.appendChild(markup());
    box.parentNode.insertBefore(b,box);
  }
  async function refresh(){
    if(busy||!grid())return;
    busy=true;
    try{
      ensure();
      let list=items();
      await Promise.all(list.map(async i=>{
        i.dataset.kpCatalogReady='1';
        const isOut=out(i);
        i.dataset.kpStock=isOut?'out':'in';
        i.classList.toggle('kp-stock-state--out',isOut);
        const p=await product(handle(i));
        if(p)addNo(i,number(p),code(p));
      }));
      list=items();
      const sorted=[...list].sort((a,b)=>rank(a)-rank(b)||String(a.dataset.kpItemNumber||'KP-999-Z').localeCompare(String(b.dataset.kpItemNumber||'KP-999-Z'),'da',{numeric:true}));
      if(sorted.some((i,idx)=>i!==list[idx])){
        const frag=document.createDocumentFragment();
        sorted.forEach(i=>frag.appendChild(i));
        grid().appendChild(frag);
        list=sorted;
      }
      visibility(list);
      controls(list);
      ensure();
    }finally{busy=false;}
  }
  async function productPage(){const h=location.pathname.match(/\/products\/([^/?#]+)/)?.[1],title=document.querySelector('.product__title');if(!h||!title||document.querySelector('.kp-product-item-number'))return;const p=await product(h);if(!p)return;const c=code(p),d=document.createElement('div');d.className='kp-product-item-number';d.textContent=`Varenr. ${number(p)} · ${label[c]||label[900]}`;title.insertAdjacentElement('afterend',d);}
  function schedule(ms=120){clearTimeout(timer);timer=setTimeout(()=>{refresh();productPage();},ms);}
  function externalChange(records){
    return records.some(r=>[...r.addedNodes].some(n=>{
      if(n.nodeType!==1)return false;
      if(n.matches?.('#product-grid')||n.querySelector?.('#product-grid'))return true;
      if(n.matches?.('.kp-machine-filterbar')||n.querySelector?.('.kp-machine-filterbar'))return true;
      if(n.matches?.('.grid__item')&&!n.dataset.kpCatalogReady)return true;
      return !!n.querySelector?.('.grid__item:not([data-kp-catalog-ready])');
    }));
  }
  document.addEventListener('change',e=>{if(!e.target.matches?.('[data-kp-hide-out-of-stock]'))return;localStorage.setItem(STOCK,e.target.checked?'1':'0');const l=items();visibility(l);controls(l);});
  document.addEventListener('DOMContentLoaded',()=>schedule(10));
  document.addEventListener('kp:machine-changed',()=>schedule(180));
  window.addEventListener('pageshow',()=>schedule(30));
  new MutationObserver(m=>{if(!busy&&externalChange(m))schedule(180);}).observe(document.documentElement,{subtree:true,childList:true});
  window.KaffePartsCatalog={version:'1.0.2',code,number,refresh:()=>schedule(0)};
})();